import { InspectionReportList } from "../../_objects/inspection-report";
import { InspectionReportListResponse } from "../responses/inspection-report.response";

export const inspectionReportListToDomain = (response: InspectionReportListResponse): InspectionReportList => {
  return {
    ...response,
    items: (response.items ?? []).map((report) => ({ ...report, inspection: report.inspections[0] }))
  };
};
